import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import styled from 'react-emotion'
// import BlockEmbedContainer from './BlockEmbedContainer'
import EmbedContainer from 'react-oembed-container'
import { withProps, withHandlers, compose } from 'recompose'
import { setBlockProperties } from '../../../store/actions/blocks'
import { colWidthSelector } from '../../../store/selectors/boardSelectors'
import { editModeSelector } from '../../../store/selectors/selectors'
import { embeds } from 'variables'
import ResizeObserver from 'resize-observer-polyfill'

const PlayButton = withProps({ children: '▶︎' })(
  styled('span')({
    fontSize: 20,
    background: 'rgba(0,0,0,0.6)',
    borderRadius: 4,
    color: 'white',
    padding: '0 4px 0 5px',
    lineHeight: 1,
    position: 'absolute',
    top: 3,
    right: 3
  })
)

const getEmbedSettings = block => {
  const provider = block.embed.provider_name.toLowerCase()
  return embeds[provider] || {}
}

const getScale = (block, width) => {
  const settings = getEmbedSettings(block)
  if (settings.baseWidth) return width / settings.baseWidth
}

const BlockEmbed = styled(
  ({ block, layout, editMode, updateAspect, className }) => {
    const settings = getEmbedSettings(block)
    const ref = useRef()
    // Update aspect
    useEffect(() => {
      // only in edit mode and for valid block (eg. not in queue)
      if (
        !settings.measureAspect || // freeform element
        !editMode || // only in edit mode
        !ref.current || // need reference to element
        // only for valid block (eg. not in queue)
        !block.id ||
        !block.column
      )
        return

      const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
          updateAspect(entry.contentRect.height / entry.contentRect.width)
        }
      })

      observer.observe(ref.current)

      return () => observer.disconnect()
    }, [
      editMode,
      !block.id,
      !block.colum,
      ref.current,
      updateAspect,
      settings.measureAspect
    ])

    return block.embed.html ? (
      <div className={className}>
        {settings.minWidth &&
        layout.width < settings.minWidth &&
        block.embed.thumbnail_url ? (
          <PlayButton />
        ) : (
          <EmbedContainer markup={block.embed.html} className="embed-container">
            <div
              className="embedHTML"
              dangerouslySetInnerHTML={{ __html: block.embed.html }}
              ref={ref}
            />
          </EmbedContainer>
        )}
      </div>
    ) : null
  }
)(({ block, layout }) => {
  const style = {
    label: 'BlockEmbed',
    height: '100%',
    background: 'transparent',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '.embed-container': {
      width: '100%',
      height: '100%'
    },
    '.embedHTML': {
      width: '100%',
      height: '100%'
    }
  }
  const settings = getEmbedSettings(block)
  const width = layout.width
  if (
    settings.minWidth &&
    layout.width < settings.minWidth &&
    block.embed.thumbnail_url
  ) {
    style.backgroundImage = `url("${block.embed.thumbnail_url}")`
  }
  const scale = getScale(block, width)
  if (scale) {
    style.width = `${100 / scale}% !important`
    if (!settings.measureAspect) style.height = `${100 / scale}% !important`
    style.transform = `scale(${scale})`
    style.transformOrigin = '0 0'
  }
  if (settings.measureAspect) {
    style['.embedHTML'].height = 'auto'
    style['.embedHTML']['& > iframe'] = {
      width: '100% !important'
    }
  } else {
    style['.embedHTML']['& > iframe'] = {
      width: '100% !important',
      height: '100% !important'
    }
  }
  switch (block.embed.provider_name.toLowerCase()) {
    case 'facebook':
      style['.embedHTML']['.fb-post'] = {
        width: '100% !important',
        '& > span, iframe': { width: '100% !important' }
      }
      break
    case 'flickr':
    case 'dropbox':
      style['.embedHTML']['img'] = {
        width: '100%',
        height: 'auto'
      }
      break
    case 'twitter':
      style['.embedHTML']['twitter-widget'] = {
        margin: '0 !important'
      }
      break
    case 'reddit':
      style['.embedHTML']['.embedly-card-hug'] = {
        margin: '0 !important'
      }
      break
    case 'pinterest':
      style['.embedHTML'].textAlign = 'center'
      break

    default:
      break
  }
  return style
})

const BlockEmbedContainer = compose(
  connect(
    state => {
      return {
        colWidth: colWidthSelector(state),
        editMode: editModeSelector(state)
      }
    },
    { setBlockProperties }
  ),
  withHandlers({
    updateAspect: ({
      block,
      layout,
      colWidth,
      setBlockProperties
    }) => aspect => {
      if (aspect === 0) return
      // if different enough
      if (Math.round(aspect * 10) !== Math.round(block.aspect * 10)) {
        setBlockProperties(block, { aspect }, { noHistory: true })
      }
    }
  })
)

export default BlockEmbedContainer(BlockEmbed)
